import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { GetUserToken } from '../models/token';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { UserItem } from '../../api/models';
import { IdentityService } from '../../api/services';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  SS_KEY = 'TheToken';
  identity: BehaviorSubject<GetUserToken | undefined> = new BehaviorSubject<GetUserToken | undefined>(undefined);
  user: BehaviorSubject<UserItem | undefined> = new BehaviorSubject<UserItem | undefined>(undefined);

  constructor(
    private jwt: JwtHelperService,
    public messageService: MessageService,
    private confirmationService: ConfirmationService,
    private router: Router,
    private identityService: IdentityService,
    @Inject(DOCUMENT) private document: Document,
     @Inject(PLATFORM_ID) private platformId: any
    ){
      if (this.getToken()) {
        this.storeUser(this.getToken()!);
      }
  }

  hasToken(){
    return this.getToken() !== undefined;
  }

  isLogged() {
    return this.user.value !== undefined;
  }

  getUser(){
    return this.user.value!;
  }

  getUserId(){
    return this.getUser().id;
  }

  getToken() {
    const localStorage = this.document.defaultView?.localStorage;
    if(!localStorage || localStorage.getItem(this.SS_KEY) === null){ return undefined }
    return localStorage.getItem(this.SS_KEY);
  }

  async storeUser(token: string) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(this.SS_KEY, token);
      const jwtDecoded = this.jwt.decodeToken(token);
      if (!jwtDecoded) {
        this.router.navigateByUrl('/login');
      }
      this.identity.next(jwtDecoded);
      await this.getMyself();
    }
  }

  getMyself() {
    return new Promise<boolean>((resolve, reject) => {
      this.identityService.identityControllerGetMyself().subscribe({
        next: (res) => {
          this.user.next(res.data);
          resolve(true);
        },
        error: (res) => {
          if (isPlatformBrowser(this.platformId)) {
            localStorage.clear();
          }
          this.identity.next(undefined);
          reject(false);
        },
      });
    });
  }

  logout() {
    this.confirmationService.confirm({
      message: "Sei sicuro di voler effettuare il logout?",
      header: 'Attenzione',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sì',
      rejectLabel: 'Annulla',
      acceptButtonStyleClass: 'bg-dialog p-button-sm',
      rejectButtonStyleClass: 'p-button-outlined p-button-sm mr-2',
      accept: () => {
        if (isPlatformBrowser(this.platformId)) {
          localStorage.clear();
        }
        this.identity.next(undefined);
        this.user.next(undefined);
        this.router.navigateByUrl('/login');
      },
    })
  }

}
